module.exports = __webpack_public_path__ + "media/images/YardStick-logo-original-onecolor-wheatfieldyellow-d95190bcc079c02052a53599a61a03dd.png";